module.exports = __webpack_public_path__ + "img/es.1dbd281f.svg";